import GlobalNavLink from '../parts/navlinks/GlobalNavLink'

const LandingPageDesktopElement = ({ cssGlobal = "",
    cssMainContent = "",
    navlink = ["/home", "Un navlink"], cssNavLink = "",
    cssSeparator = "",
    cssImg = "", img = null, imgAlt = "Une image",
    child = null }) => {

    const sectionCss = `flexJustifyItemsCenter gap-12 w-full h-1/2 ${cssGlobal}`
    const contentDivCss = `flex items-start pr-6 py-6 w-11/12 h-full rounded-2xl ${cssMainContent}`
    const separatorSpanCss = `w-2 h-2/6 rounded-2xl ${cssSeparator}`
    const visualImgCss = `absolute w-32 flexJustifyItemsCenter ${cssImg}`
    const navLinkCss = `w-36 text-darkRed ${cssNavLink}`

    return (
        <section className={sectionCss}>
            <div className="flex justify-between items-start flex-col h-full break-all">
                <span className={separatorSpanCss} />
                <div className='relative flexJustifyItemsCenter'>
                    <div className={visualImgCss}>
                        <img className="w-32 h-32 rounded-full" src={img[1]} alt={imgAlt} />
                    </div>
                </div>
                <span className={separatorSpanCss} />
            </div>
            <div className={contentDivCss}>
                <GlobalNavLink type="landingPage" to={navlink[0]} txt={navlink[1]} css={navLinkCss} img={img[0]} />
                {child && child}
            </div>
        </section>
    )
}

export default LandingPageDesktopElement